import styled, { css } from 'styled-components'
import {
  BREAKPOINT_QUERIES,
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const desktopQuery = createResponsiveBreakpointQuery('desktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.collectionDesktopUp
})

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  overflow: hidden;
  padding: 1rem 2rem;

  ${({ $isPlaylistLibrary }) =>
    $isPlaylistLibrary &&
    css`
      gap: 16px;
      padding: 16px;

      @media ${BREAKPOINT_QUERIES.tabletUp} {
        padding: 16px 24px;
      }
    `}

  ${({ $isWelcome }) =>
    $isWelcome &&
    css`
      gap: 24px;
      padding: 16px 0 0 16px;

      @media ${BREAKPOINT_QUERIES.tabletUp} {
        padding: 16px 24px 0;
      }

      @media ${BREAKPOINT_QUERIES.desktopUp} {
        gap: 72px;
      }
    `}
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 1rem;
  padding-top: 1.5rem;
  padding-bottom: 2rem;

  ${({ $isPlaylistLibrary }) =>
    $isPlaylistLibrary &&
    css`
      min-height: 32px;
      padding: 0;
      margin-bottom: 4px;

      @media ${BREAKPOINT_QUERIES.tabletUp} {
        margin-bottom: 0;
      }

      @media ${BREAKPOINT_QUERIES.desktopUp} {
        margin-bottom: 24px;
      }
    `}

  ${({ $isWelcome }) =>
    $isWelcome &&
    css`
      min-height: 32px;
      padding: 0 16px 0 0;

      @media ${BREAKPOINT_QUERIES.tabletUp} {
        padding-right: 0;
      }
    `}
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

export const Title = styled.p`
  margin-right: 1.5rem;
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
  color: white;
  font-size: 1rem;
  white-space: pre;
  letter-spacing: 0.2em;
  position: relative;
  margin-bottom: 5px;

  ${({ $isWelcome }) =>
    $isWelcome &&
    css`
      font-size: 20px;
      font-weight: 700;
      letter-spacing: 0;
      margin: 0;
      text-transform: none;

      @media ${BREAKPOINT_QUERIES.tabletUp} {
        font-size: 16px;
      }
    `}

  @media ${desktopQuery} {
    ${({ $isWelcome, $isPlaylistLibrary }) =>
      !$isWelcome &&
      !$isPlaylistLibrary &&
      css`
        font-size: 1.25rem;
        letter-spacing: 0.5em;
      `}
  }

  ${({ $isPlaylistLibrary }) =>
    $isPlaylistLibrary &&
    css`
      font-size: 20px;
      font-weight: 700;
      letter-spacing: 0;
      margin: 0;
      text-transform: none;
    `}
`

export const IconContainer = styled.div`
  color: white;
  align-items: center;
  justify-content: center;
`

export const ActionButton = styled.button`
  min-height: 2rem;
  padding: 0 1rem;
  background-color: #777a;
  color: white;
  border-radius: 9999px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  margin-right: 2rem;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  @media ${desktopQuery} {
    margin-right: 4rem;
    padding: 0 1em; // Adjust padding for larger screens
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  overflow-y: ${({ $disableScroll }) =>
    $disableScroll ? 'hidden' : 'auto'};

  ${({ $isPlaylistLibrary }) =>
    $isPlaylistLibrary &&
    css`
      @media ${BREAKPOINT_QUERIES.desktopUp} {
        margin-top: 8px;
      }
    `}

  ${({ $isWelcome }) =>
    $isWelcome &&
    css`
      flex-grow: 0;
      overflow: hidden;
    `}
`
